import { PrivateRoute } from '@/src/components/Components/PrivateRoute';
import { VendorDashboardPage } from '@/src/components/Dashboards/VendorDashboardPage';
const VendorDashboard = () => {
  return <PrivateRoute data-sentry-element="PrivateRoute" data-sentry-component="VendorDashboard" data-sentry-source-file="index.tsx">
      <VendorDashboardPage data-sentry-element="VendorDashboardPage" data-sentry-source-file="index.tsx" />
    </PrivateRoute>;
};
export default VendorDashboard;